import { render, staticRenderFns } from "./challenge_card.vue?vue&type=template&id=82854e5c&scoped=true&"
import script from "./challenge_card.vue?vue&type=script&lang=js&"
export * from "./challenge_card.vue?vue&type=script&lang=js&"
import style0 from "./challenge_card.vue?vue&type=style&index=0&id=82854e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82854e5c",
  null
  
)

export default component.exports